import * as React from "react";
import { connect } from "react-redux";
import { Checkbox, Stack } from "@mantine/core";
import { IState } from "../../../../data/reducers/state";
import { IVenue } from "../../../../types/venue/Venue";

interface IShiftVenueEditorProps {
  associationId: string;
  shiftId: string | null;
  venues: string[];
  allVenues: string[];
  venueMap: { [id: string]: IVenue };
  onEdit: (name: string, venues: string[]) => void;
}

const ShiftVenueEditor: React.FunctionComponent<IShiftVenueEditorProps> = ({
  venues,
  venueMap,
  allVenues,
  onEdit,
}) => {
  const vs = new Set(venues);
  const unionVenues = Array.from(
    new Set([...venues, ...(allVenues || [])]),
  ).sort();
  const revisedVenues = (venue: string, shouldAdd: boolean) =>
    shouldAdd ? [...venues, venue] : venues.filter((r) => r !== venue);

  return (
    <>
      <br />
      <p style={{ color: "gray" }}>
        Please contact your{" "}
        <a href="mailto:support@stadiumsupervisor.com.au">
          system administrator
        </a>{" "}
        to edit venues for this shift.
      </p>

      <Stack gap="md">
        {unionVenues.map((v, idx) => {
          const venue = venueMap?.[v];
          if (!venue) {
            return (
              <p key={v}>
                Couldn't find a venue with _id: {v}
              </p>
            );
          }

          return (
            <Checkbox
              key={v}
              checked={vs.has(v)}
              label={venue.name}
              onChange={(event) =>
                onEdit("venues", revisedVenues(v, event.currentTarget.checked))
              }
              style={{ padding: "6px 3px" }}
              size="md"
            />
          );
        })}
      </Stack>
    </>
  );
};

function mapStateToProps(state: IState, ownProps: IShiftVenueEditorProps) {

  return {
    venueMap: state.venues.map,
    allVenues: state.venues.byAssociation[ownProps.associationId] || [],
  };
}

export default connect(mapStateToProps)(ShiftVenueEditor);
